// Pak module definition
define('app/pak',['require','App','dtm','jquery','components/modernizr/modernizr','lib/vp.jquery.excerpt','lib/vp.excerpt2','cookies','vendor/jquery.form','validate','maskedinput','components/es5-shim/es5-shim','components/es5-shim/es5-sham','vendor/json2','URIjs/URI','flight-components/Router','flight-components/Viewport','flight-components/Analytics','flight-components/GeoDialog','flight-components/Account','flight-components/GeoSearch','flight-components/Social','flight-components/Hero','flight-components/SideDrawer','flight-components/ListingResults','flight-components/CategoryList','flight-components/KeywordSearch','flight-components/ui/Popover','flight-components/Dropdown','flight-components/FlashMessage','flight-components/SurveyToolbar','flight-components/ResponseModeToolbar','flight-components/ImageGallery'],function(require){

  // require('dtm');

  // Load common plugins and dependencies
  var App = require('App');

  require('dtm');
  require('jquery');
  require('components/modernizr/modernizr');

  // Plugins
  require('lib/vp.jquery.excerpt');
  require('lib/vp.excerpt2');
  require('cookies');
  require('vendor/jquery.form');
  require('validate');
  require('maskedinput');

  // Shims
  require('components/es5-shim/es5-shim');
  require('components/es5-shim/es5-sham');
  require('vendor/json2');

  var URI = require('URIjs/URI');

  // require Selectivizr for IE <= 8
  if ($('html').hasClass('lte-ie8')) require(['components/selectivizr/selectivizr']);

  // Make it safe to do console.log() always.
  (function(con) {
    'use strict';
    var prop, method;
    var empty = {};
    var dummy = function() {};
    var properties = 'memory'.split(',');
    var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
       'groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,' +
       'table,time,timeEnd,timeStamp,trace,warn').split(',');
    while (prop = properties.pop()) con[prop] = con[prop] || empty;
    while (method = methods.pop()) con[method] = con[method] || dummy;
  })(this.console = this.console || {}); // Using `this` for web workers.

  // Listen for print messages from postMessage
  // This is for syndicated partners so that they can
  // print the contents of our iframe from their
  // domain.
  window.addEventListener('message', function(e) {
    if (e.data === 'print'){
      window.print()
    }
  });

  // FHP Geo Translator
  function fhpGeoTranslator(franId) {
    var url = 'https://api.valpak.com/pub/fran/franchises';
    var params = {};
    var query = true;

    if (franId && franId !== 3061)
      url += '/' + franId;
    else if (App.results.franchiseId != 0)
      url += '/' + App.results.franchiseId;
    else if (App.results.postalCode)
      params.postalCode = App.results.postalCode;
    else
      query = false;

    if (query) {
      $.ajax({
        url: url,
        type: 'GET',
        data: params,
        xhrFields: {
          withCredentials: true
        },
        beforeSend: function(xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer Ha6Op30RIMNkxEAIJrSx7ggU6gSXdV6okfp6qIMbGuw');
        },
        success: function(franchise) {
          if (franchise.franchiseId != 7) {
            $('.fhpLink').attr('href', '/advertise/local/' + franchise.franchiseURL);
            $('.fhpText').html('Grow Your Business With ' + franchise.franchiseName);
            $('.fhpLink img').attr('alt', 'Advertise your business with ' + franchise.franchiseName);
          }
        }
      });
    }
  }

  // Document Ready
  $(function(){

    // Attach our jQuery plugins
    //
    $('[data-excerpt]').excerpt();
    $('.js-collapsable').collapsable();

    // Geo change event triggers
    //
    // Triggers the event that will activate the geo search component.
    $('.js-geo-change').on('click', function(ev) {
      ev.preventDefault();

      var redirect = true;
      if (typeof $(this).data('geoRedirect') !== 'undefined') {
        redirect = $(this).data('geoRedirect');
      }
      $(this).trigger('ui-needs-geo-change', {redirect: redirect});
    });

    $('.js-category-list').on('click', function(e) {
      e.preventDefault();
      $(this).trigger('ui-needs-category-list')
    });

    $('.js-contest-entry').on('click', function(e) {
      e.preventDefault();
      $(this).trigger('ui-needs-contest-entry', {})
    });

    // Keyword search event triggers (popover)
    //
    $('.toggle__mini-search').on('click', function(ev) {
      $('input[name="keywords"]').focus();
    });

    // Survey click counts triggers
    //
    // Clicks on elements with a data-dtm attribute should
    // increment a running click count. This is only enabled
    // if the user is eligible for the survey.
    if (App.user.enableSurvey) {
      $(document).on('click', '[data-dtm]', function() {
        $(this).trigger('ui-increment-action-count-requested');
      });
    }

    // TODO: temp hack
    //
    // Make featured merchant URLs in primary sidebar
    // relative to the app context
    $('[data-dtm="featured-merchant-tiles"] a').each(function(){
      var href = URI($(this).attr('href'));
      if (href.is('relative')) {
        var newHref = href.absoluteTo(App.context + '/').toString();
        $(this).attr('href', newHref);
      }
    });

    // Display the SDC grocery iFrame when its finished loading
    if (App.page == 'groceryResults' || App.page == 'browseByState') {
      $('.iframe-loader').hide();
    }

    if (App.page == 'mailinglistaddition') {
      $("#mailAddressAdditionForm").ajaxForm({
        dataType: 'json',
        success: function(data) {
          if (data.content.exception == "Address Already Added") {
            $("#form__guts").hide();
            $("#form__error").hide();
            $("#form__success").show();
            $("#form__success h4").html('We have already received your request to add your address');
          }
          else if (data.status == "dbError") {
            $("#form__guts").hide();
            $("#form__error").show();
          }
          else if (data.status == "uspsError") {
            $("#form__error").show();
            $("#form__error p").hide();
            $("#form__error h4").html(data.content);
          }
          else {
            $("#form__guts").hide();
            $("#form__error").hide();
            $("#form__success").show();
          }
        }
      });
    }

    if (App.page == 'mailinglistsuppression') {
      $("#mailAddressRemovalForm").ajaxForm({
        dataType: 'json',
        success: function(data) {
          if (data.content.exception == "Address Already Removed") {
            $("#form__guts").hide();
            $("#form__error").hide();
            $("#form__success").show();
            $("#form__success h4").html('We have already received your request to remove your address');
          }
          else if (data.status == "dbError") {
            $("#form__guts").hide();
            $("#form__error").show();
          }
          else if (data.status == "uspsError") {
            $("#form__error").show();
            $("#form__error p").hide();
            $("#form__error h4").html(data.content);
          }
          else {
            $("#form__guts").hide();
            $("#form__error").hide();
            $("#form__success").show();
          }
        }
      });
    }

    // Setup coupon carousels
    if (App.page == 'popularResults' || App.page == 'bpp') {
      var localCount = $(".owl-local").data("localcount");
      var itemCount = 3;

      var excludes = [2, 4, 5, 8, 12, 16, 20, 24];

      for (var i = 0; i < excludes.length; i++) {
        if (localCount == excludes[i]) {
          itemCount = 2;
        }
        else if (localCount == 1) {
          itemCount = 1;
        }
      }

      $(".owl-local").owlCarousel({
        items: itemCount,
        itemsDesktop: [1199,itemCount],
        itemsDesktopSmall: [979,2],
        itemsTablet: [780,2],
        navigation: true,
        scrollPerPage: true,
        navigationText: [
          "<i class='icon-left-open'></i>",
          "<i class='icon-right-open'></i>"
        ],
        afterInit: function() {
          setTimeout(function() {
            $(".owl-carousel ul").css({display: 'flex'});
            $(".listing-loader").css({display: 'none'});
          }, 200);

          if (App.user.device.type === 'tablet') {
            if (App.user.device.deviceOS.toLowerCase() === 'ios') {
              $(".owl-carousel ul").css({display: '-webkit-flex'});
            }
          }

          if (App.user.device.type === 'handheld') {
            $(".owl-pagination").css({display: 'none'});
          }

          setTimeout(function() {$('body').scrollTop(0);}, 500);
        }
      });
    }

    if (App.page == 'popularResults') {
      $(".owl-online").owlCarousel({
        items: 3,
        itemsDesktop: [1199,3],
        itemsDesktopSmall: [979,2],
        itemsTablet: [780,2],
        navigation: true,
        scrollPerPage: true,
        navigationText: [
          "<i class='icon-left-open'></i>",
          "<i class='icon-right-open'></i>"
        ],
        afterInit: function() {
          setTimeout(function() {
            $(".owl-carousel ul").css({display: 'flex'});
            $(".listing-loader").css({display: 'none'});
          }, 200);

          if (App.user.device.type === 'tablet') {
            if (App.user.device.deviceOS.toLowerCase() === 'ios') {
              $(".owl-carousel ul").css({display: '-webkit-flex'});
            }
          }

          if (App.user.device.type === 'handheld') {
            $(".owl-pagination").css({display: 'none'});
          }

          setTimeout(function() {$('body').scrollTop(0);}, 500);
        }
      });
    }

    // After the coupons load on the promotion page hide the loader and display coupons
    if (App.page.substr(0, 9) == 'promotion') {
      var promos = document.querySelectorAll('.results-listing--promo');
      var loader = document.querySelector('.listing-loader');
      var array = Array.prototype.slice.call(promos);
      setTimeout(function() {
        array.forEach(function(promos) {
          promos.style.display = 'block';

          if (loader) {
            loader.style.display = 'none';
          }
        })
      }, 250);

      // Load inmar iframes
      $(function() {
        $('.inmar_iframe-single iframe').each(function() {
          // iframe URL is on a `data` attribute to delay loading
          this.src = this.getAttribute('data-src');
        });
      })
    }

    /*
     * Add rel="nofollow" on BPP pages
     */
    if (App.page === 'bpp') {
      $(".bpp__marketing-message").find("a").attr("rel", "nofollow");
      $(".urls").find("a").attr("rel", "nofollow");
      $(".urls").find("a:first").removeAttr("rel");
    }

    /*
     * FHP toolbar cookie
     */
    // if (!$.cookie('no_biz') && App.page === 'welcome') {
    //   $('.fhp-toolbar').show();
    // }
    // if ($('.fhp-toolbar').length > 0) {
    //   $('.nobiz').on("click", function() {
    //     $.cookie('no_biz', true, {expires:180, path:'/'});
    //     $('.fhp-toolbar').hide();
    //   });
    // }

    /*
     * Offset horizontal scrollers on smaller screens
     */
    // if (App.page === 'welcome' || App.page === 'sdcFeatured') {
    //   if ($(window).width() > 330 && $(window).width() < 380)
    //     $(".slider-overflow").scrollLeft(45);
    //   else if ($(window).width() > 380 && $(window).width() < 430)
    //     $(".slider-overflow").scrollLeft(5);
    //   else if ($(window).width() > 430 && $(window).width() < 810)
    //     $(".slider-overflow").scrollLeft(40);
    // }


    /*
     * Browser Geocode location
     */
    if (App.page === 'welcome') {
      // If toggle VPCOM_WELCOME_GEOCODE is true
      if (App.toggleWelcomeGeocode && navigator.geolocation) {
        // Add loader
        $('#localContent .box-offers').addClass('loading-mask');
        $('#localContent .box').addClass('loading-mask-content');

        var geoSuccess = function(position) {
          // Get the coordinates of the current possition.
          var lat = position.coords.latitude.toFixed(8);
          var lng = position.coords.longitude.toFixed(8);
          var acc = position.coords.accuracy;

          if (lat != '' && lng != '') {
            console.log('Latitude: ' +lat+ ' ....... Longitude: ' +lng);
            console.log('Location Accuracy in Meters: ' + acc);

            // Send browser geo coords
            $.ajax({
              url: App.context + '/localContent',
              type: 'GET',
              data: {lat: lat, long: lng},
              success: function(resp) {
                // Update local content with more accurate results
                $('#localContent').replaceWith(resp);

                // Triggers the event that will activate the geo search component
                $('.js-geo-changer').on('click', function(ev) {
                  ev.preventDefault();

                  // make sure f1 value is 'home'
                  $('#f1').val('home');

                  var redirect = true;
                  if (typeof $(this).data('geoRedirect') !== 'undefined') {
                    redirect = $(this).data('geoRedirect');
                  }
                  $(this).trigger('ui-needs-geo-change', {redirect: redirect});
                });

                // Populate the 'local coupons' link in the header
                if ($('.js-vml').length) {
                  $('.header__alt-links .js-geo-change').attr('href', $('.js-vml').attr('href')).off();
                }

                // FHP Geo Translator
                fhpGeoTranslator($('.lc').attr('data-fid'));
              },
              error: function(resp) {
                setTimeout(hideLoader, 5000);
              }
            });
          }
          else {
            setTimeout(hideLoader, 5000);
          }
        };

        var geoError = function(error) {
          switch(error.code) {
            case error.PERMISSION_DENIED:
              // The user didn't accept the callout
              console.log('Geolocation error ....... Error code: ' + error.code);
              $('#geo-search').show();
              setTimeout(hideLoader, 5000);
              break;
            case error.TIMEOUT:
              // Timeout
              console.log('Geolocation error ....... Error code: ' + error.code);
              $('#geo-search').show();
              setTimeout(hideLoader, 5000);
              break;
          }
        };

        // Remove loader
        var hideLoader = function() {
          $('#localContent .box-offers').removeClass('loading-mask');
          $('#localContent .box').removeClass('loading-mask-content');
        };

        navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
      }
    }

    /*
     * FHP Geo Translator
     */
    if (App.page === 'bpp') {
      fhpGeoTranslator($('.bpp__code').attr('data-fid'));
    }
    else {
      fhpGeoTranslator();
    }

    // Fade card
    $(".fadecard").on('click', function() {
      $(this).toggleClass('is-faded');
    });
    // Flip card
    $(".flipcard").on('click', function() {
      $(this).toggleClass('is-flipped');
    });

  });


  function init() {

    // Attach common flight components
    require('flight-components/Router').attachTo(document);
    require('flight-components/Viewport').attachTo(document);
    require('flight-components/Analytics').attachTo(document);
    require('flight-components/GeoDialog').attachTo(document);
    require('flight-components/Account').attachTo(document);

    $(document).ready(function(){
      require('flight-components/GeoSearch').attachTo('[data-component="geo-search"]');
      require('flight-components/Social').attachTo('[data-component="Social"]');
      require('flight-components/Hero').attachTo('.hero');
      require('flight-components/SideDrawer').attachTo('[data-role="off-canvas-nav"]');
      require('flight-components/ListingResults').attachTo('.listings');
      require('flight-components/CategoryList').attachTo('.js-category-list');
      // require('flight-components/RSSGen').attachTo('[data-component="RSSGen"]');
      require('flight-components/KeywordSearch').attachTo('[data-component="KeywordSearch"]');
      require('flight-components/ui/Popover').attachTo('[data-popover]');
      require('flight-components/Dropdown').attachTo('.js-dropdown');
      require('flight-components/FlashMessage').attachTo('[data-component="FlashMessage"]');
      require('flight-components/SurveyToolbar').attachTo('[data-component="SurveyToolbar"]');
      require('flight-components/ResponseModeToolbar').attachTo('[data-component="ResponseModeToolbar"]');
      require('flight-components/ImageGallery').attachTo('[data-component="ImageGallery"]');

      // Trigger custom event to indicate all
      // components have been instantiated
      $(document).trigger('appComponentsLoaded');

      // Remove .js-fouc class
      //
      // Earlier we added .js-fouc to the <html> classes
      // so that we could hide certain content prior to JS
      // being loaded. Here is the time to remove it.
      $('html').removeClass('js-fouc');

    });
  }

  return init;
});

